import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from "../../../components/DataTable/DataTable";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProjectModel from "../../../models/ProjectModel";
import ProjectReferenceModel from "../../../models/ProjectReferenceModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ExportModel {
    projectId: number
    projectReferences: ProjectReferenceModel[]
}
interface IProps extends PopupProps {
    project: ProjectModel
}

const ExportprojectPopup: React.FC<IProps> = ({ show, onHide, project }) => {
    const { handleResult, handleException } = useNotifications();
    const [data, setData] = useState<ExportModel>();

    useEffect(() => {
        getData()
    }, [project]);

    function getData() {
        if (project) {
            DataService.get<ProjectReferenceModel[]>('api/v1/ProjectReferences/ByProjectForExport/' + project.id)
                .then(response => {
                    setData({
                        projectId: project.id,
                        projectReferences: response
                    })
                })
        }
    }

    function submit() {
        if (data) {
            data.projectReferences = data.projectReferences.filter(x => x['_checkbox_export'] === true)
            DataService
                .post<Result>(`api/v1/ProjectReferences/export`, data)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true)
                        onHide();
                    else
                        getData();
                })
                .catch(e => handleException(e));
        }
    }

    function selectAllRows(selectedRows: any[]) {
        if (data) {
            if (selectedRows.length != data.projectReferences.length)
                data.projectReferences.forEach(r => r['_checkbox_export'] = true)
            else
                data.projectReferences.forEach(r => r['_checkbox_export'] = false)

            setData(x => ({ ...data }))
        }
    }


    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Export project'} >
            <Popup.Body>
                {data && (
                    <DataTable
                        name='dtProjectExport'
                        colInfos={[
                            { key: true, dataProp: 'id', visible: false },
                            { checkboxButton: { icon: 'fa-check', color: 'green', text: 'export', onClick: (selectedRows) => { selectAllRows(selectedRows); } } },
                            { title: 'External System', dataProp: 'externalSystemName' },
                            { title: 'Reference code', dataProp: 'referenceCode' },
                            { title: 'Ready on', dataProp: 'readyForExportOn', dataType: 'datetime' },
                            { title: 'Exported on', dataProp: 'exportedOn', dataType: 'datetime' },
                        ]}
                        tableData={data.projectReferences}
                    />
                )}
            </Popup.Body>
            <Popup.Footer>
                <Button text="Export" type='button' onClick={submit} />
            </Popup.Footer>
        </Popup>
    );
}
export default ExportprojectPopup;